import * as Yup from "yup";

export class PLDSchema {
  public static id() {
    return Yup
      .number()
      .positive("Id deve ser um maior que zero");
  }

  public static record() {
    return Yup
      .object()
      .shape(recordShape);
  }

  public static createForm() {
    const {
      anoMes,
      SE,
      S,
      NE,
      N,
    } = recordShape;

    const createFormShape = {
      anoMes,
      SE,
      S,
      NE,
      N,
    };

    return Yup
      .object()
      .shape(createFormShape);
  }

  public static updateForm() {
    const {
      anoMes,
      SE,
      S,
      NE,
      N,
    } = recordShape;

    const updateFormShape = {
      anoMes,
      SE,
      S,
      NE,
      N,
    };

    return Yup
      .object()
      .shape(updateFormShape);
  }
}

const recordShape = {
  SE: Yup.number(),
  S: Yup.number(),
  NE: Yup.number(),
  N: Yup.number(),
  anoMes: Yup.string(),
};
